/* eslint-disable camelcase */
/* global smily */

class RentalsFormPagination extends HTMLElement {
  paginate(pagination, filters) {
    const { total_count, total_pages, page } = pagination;
    const { t } = smily.website;
    const { rentalsCount } = t.rentalsForm.pagination;

    if (!total_count) {
      this.innerHTML = '';
      return;
    }

    // reset content
    this.innerHTML = `
      <b class="d-block mb-3">
        ${smily.t(rentalsCount[total_count < 2 ? 'one' : 'other'], { count: total_count })}
      </b>
    `;

    const isFirstPage = page === 1;
    const isLastPage = page === total_pages;

    const url = new URL(window.location);
    url.search = new URLSearchParams(filters);

    const pageUrl = (index) => {
      url.searchParams.set('page', index);
      return url;
    };

    // create list
    const ul = document.createElement('ul');
    ul.setAttribute('class', 'pagination justify-content-center mb-0');

    // create previous button
    const previous = document.createElement('li');
    previous.setAttribute('class', 'page-item');

    if (isFirstPage) previous.classList.add('disabled');

    previous.innerHTML = `
      <a class="page-link rounded prev" href="${isFirstPage ? '#' : pageUrl(page - 1)}" title="${t.rentalsForm.pagination.previous}">
        <span class="icon-group py-1">${smily.svgIcon('leftArrowAlt')}</span>
      </a>
    `;

    ul.appendChild(previous);

    // create list items

    const pageOffset = Math.max(page - 3, 0);
    const itemsLimit = 5;

    if (pageOffset > 0) {
      ul.insertAdjacentHTML('beforeend', `<li class="page-item"><a class="page-link rounded" href="${pageUrl(1)}">1</a></li>`);

      if (pageOffset !== 1) {
        ul.insertAdjacentHTML('beforeend', '<li class="page-item disabled"><a class="page-link rounded" href="#">…</a></li>');
      }
    }

    for (let i = 1 + pageOffset; i <= total_pages && i <= itemsLimit + pageOffset; i += 1) {
      const li = document.createElement('li');
      li.classList.add('page-item');

      if (i === page) li.classList.add('active');

      const a = document.createElement('a');
      a.setAttribute('class', 'page-link rounded');
      a.textContent = i;
      a.href = pageUrl(i);

      li.appendChild(a);
      ul.appendChild(li);
    }

    if (pageOffset + itemsLimit < total_pages) {
      if (pageOffset + itemsLimit + 1 !== total_pages) {
        ul.insertAdjacentHTML('beforeend', '<li class="page-item disabled"><a class="page-link rounded" href="#">…</a></li>');
      }

      ul.insertAdjacentHTML('beforeend', `<li class="page-item"><a class="page-link rounded" href="${pageUrl(total_pages)}">${total_pages}</a></li>`);
    }

    // create next button
    const next = document.createElement('li');
    next.setAttribute('class', 'page-item');

    if (isLastPage) next.classList.add('disabled');

    next.innerHTML = `
      <a class="page-link rounded prev" href="${isLastPage ? '#' : pageUrl(page + 1)}" title="${t.rentalsForm.pagination.next}">
        <span class="icon-group py-1">${smily.svgIcon('rightArrowAlt')}</span>
      </a>
    `;

    ul.appendChild(next);

    this.appendChild(ul);
  }
}

customElements.define('rentals-form-pagination', RentalsFormPagination);
